module.exports = __webpack_public_path__ + "static/media/warning-circle-yellow.1b3558a4.svg";